// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 261 ? "locale-fr-json" : chunkId) + "." + {"261":"cda36682","453":"977729c1"}[chunkId] + ".chunk.js";
};